import React from 'react';

const AfterRelatedItems = ({ content }) => {
  return <></>;
};
export default AfterRelatedItems;
